import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { LoadingService } from './loading/loading.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) { }
  handleError(error) {
    const loadingService = this.injector.get(LoadingService);

    loadingService.hideLoading();
    location.reload();
    console.log(error);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/error.handler.ts